import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[appImageFallback]',
  standalone: false,
})

/**
 * @description: This directive is used to set a fallback image in case the original image is not found
 * @example:    <img [appImageFallback]="'https://via.placeholder.com/200;'" src="image.jpg">
 *         If the image.jpg is not found, the directive will set the src to the fallback image
 */
export class ImageFallbackDirective {
  /**
   * @description: The fallback image to be used in case the original image is not found
   * @type: {string}
   */
  @Input() appImageFallback: string;

  constructor(private eRef: ElementRef) {}

  /**
   * @description: This method is called when the image is not found
   * It sets the src of the image to the fallback image
   */
  @HostListener('error')
  loadFallback() {
    this.eRef.nativeElement.src = this.appImageFallback;
    const element: HTMLImageElement = <HTMLImageElement>this.eRef.nativeElement;
    element.src = this.appImageFallback || 'https://via.placeholder.com/200;';
  }
}
